export default __webpack_public_path__ + "static/media/brazil (1).0ae031e7.png";